import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=744b98c8&scoped=true&"
import script from "./IssueDetail.vue?vue&type=script&lang=js&"
export * from "./IssueDetail.vue?vue&type=script&lang=js&"
import style0 from "./IssueDetail.vue?vue&type=style&index=0&id=744b98c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b98c8",
  null
  
)

export default component.exports